import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import {  useAppTheme } from '../Context/ThemeContext';

const ThemeSwitcher = () => {
    const { darkMode, toggleTheme } = useAppTheme();
    const theme = useTheme();
  
    return (
      <Tooltip title={`Switch to ${darkMode ? 'light' : 'dark'} mode`}>
        <IconButton
          onClick={toggleTheme}
          sx={{
            ml: 1,
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            }
          }}
        >
          {darkMode ? 
            <Brightness7Icon color="primary" /> : 
            <Brightness4Icon color="inherit" />
          }
        </IconButton>
      </Tooltip>
    );
  };
  

export default ThemeSwitcher;
